import React, { useState } from 'react';
import { Badge, Button, Card, Container, Form, Modal, Table } from 'react-bootstrap';
import { showToast, toastMessages } from '../../../utils/toast';

const ApiPartnerIpWhiteListing = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    ipAddress: '',
    remarks: ''
  });
  const [errors, setErrors] = useState({
    ipAddress: '',
    remarks: ''
  });

  const [ipHistory, setIpHistory] = useState([
    {
      ip: '13.232.45.218',
      dateTime: '2025-11-05 09:30 AM',
      status: 'Enabled'
    },
    {
      ip: '13.232.45.219',
      dateTime: '2025-11-02 04:45 PM',
      status: 'Disabled'
    },
    {
      ip: '15.206.11.49',
      dateTime: '2025-10-26 12:10 PM',
      status: 'Enabled'
    },
    {
      ip: '15.206.11.51',
      dateTime: '2025-10-18 08:55 AM',
      status: 'Disabled'
    }
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Enabled':
        return 'success';
      case 'Disabled':
        return 'secondary';
      default:
        return 'light';
    }
  };

  const handleStatusToggle = (ip) => {
    let updatedStatus = '';
    setIpHistory((prev) =>
      prev.map((entry) => {
        if (entry.ip !== ip) {
          return entry;
        }
        const status = entry.status === 'Enabled' ? 'Disabled' : 'Enabled';
        updatedStatus = status;
        return { ...entry, status };
      })
    );
    if (updatedStatus) {
      showToast.success(`IP ${ip} ${updatedStatus.toLowerCase()}.`);
    }
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    return now.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const handleOpenModal = () => setShowModal(true);

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      ipAddress: '',
      remarks: ''
    });
    setErrors({
      ipAddress: '',
      remarks: ''
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: ''
    }));
  };

  const validateForm = () => {
    const tempErrors = {
      ipAddress: '',
      remarks: ''
    };

    const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

    if (!formData.ipAddress.trim()) {
      tempErrors.ipAddress = 'IP address is required.';
    } else if (!ipRegex.test(formData.ipAddress.trim())) {
      tempErrors.ipAddress = 'Enter a valid IPv4 address.';
    }

    if (!formData.remarks.trim()) {
      tempErrors.remarks = 'Remarks are required.';
    }

    setErrors(tempErrors);
    return !Object.values(tempErrors).some((message) => message);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) {
      showToast.error(toastMessages.validationError);
      return;
    }

    const trimmedIp = formData.ipAddress.trim();

    const alreadyExists = ipHistory.some((entry) => entry.ip === trimmedIp);
    if (alreadyExists) {
      showToast.error('This IP address is already in the list.');
      return;
    }

    const newEntry = {
      ip: trimmedIp,
      dateTime: getCurrentDateTime(),
      status: 'Disabled'
    };

    setIpHistory((prev) => [...prev, newEntry]);
    showToast.success(`IP ${trimmedIp} added successfully.`);
    handleCloseModal();
  };

  return (
    <Container fluid className="api-partner-ip-whitelisting p-4">
      <div className="page-header mb-4 d-flex justify-content-between align-items-center">
        <div>
          <h2 className="mb-1" style={{ fontSize: '24px', fontWeight: 600, color: '#2c2268' }}>
            <i className="bi bi-shield-lock me-2"></i>
            IP Whitelisting
          </h2>
        </div>
        <Button
          onClick={handleOpenModal}
          style={{
            backgroundColor: '#1e1850',
            border: 'none',
            padding: '10px 24px',
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: '15px',
            boxShadow: '0 4px 6px rgba(30, 24, 80, 0.3)'
          }}
        >
          <i className="bi bi-plus-circle me-2"></i>
          New IP
        </Button>
      </div>

      <Card className="shadow-sm border-0">
        <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
          {/* <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
            <i className="bi bi-clock-history me-2"></i>
            Whitelisting History
          </h5> */}
        </Card.Header>
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table hover className="mb-0">
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px', textAlign: 'center' }}>
                    IP
                  </th>
                  <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px', textAlign: 'center' }}>
                    Date &amp; Time
                  </th>
                  <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px', textAlign: 'center' }}>
                    Status
                  </th>
                  <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px', textAlign: 'center' }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {ipHistory.map((entry) => (
                  <tr key={entry.ip} style={{ transition: 'background-color 0.2s' }}>
                    <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600, textAlign: 'center' }}>
                      {entry.ip}
                    </td>
                    <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px', textAlign: 'center' }}>
                      {entry.dateTime}
                    </td>
                    <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                      <Badge
                        bg={getStatusColor(entry.status)}
                        style={{
                          fontSize: '11px',
                          padding: '4px 10px',
                          fontWeight: 500,
                          width: '90px'
                        }}
                      >
                        {entry.status}
                      </Badge>
                  </td>
                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                    <Button
                      size="sm"
                      variant={entry.status === 'Enabled' ? 'outline-danger' : 'outline-success'}
                      onClick={() => handleStatusToggle(entry.ip)}
                      style={{ fontSize: '12px', fontWeight: 600, minWidth: '110px' }}
                    >
                      {entry.status === 'Enabled' ? 'Disable' : 'Enable'}
                    </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6', padding: '16px 24px' }}>
          <Modal.Title style={{ fontSize: '20px', fontWeight: 600, color: '#333' }}>
            Add IP Address
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '24px' }}>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
                IP Address <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="ipAddress"
                placeholder="e.g. 13.232.45.218"
                value={formData.ipAddress}
                onChange={handleInputChange}
                isInvalid={!!errors.ipAddress}
                style={{
                  padding: '10px 14px',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
                required
              />
              <Form.Control.Feedback type="invalid">{errors.ipAddress}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
                Remarks <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="remarks"
                placeholder="Share infrastructure or firewall notes"
                value={formData.remarks}
                onChange={handleInputChange}
                isInvalid={!!errors.remarks}
                style={{
                  padding: '10px 14px',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
              />
              <Form.Control.Feedback type="invalid">{errors.remarks}</Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: '1px solid #dee2e6', padding: '16px 24px' }}>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            style={{
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 500,
              borderRadius: '4px'
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleSubmit}
            className="send-button"
            style={{
              backgroundColor: 'transparent',
              border: '2px solid #0d6efd',
              color: '#0d6efd',
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '4px',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#0d6efd';
              e.currentTarget.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#0d6efd';
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx="true">{`
        .api-partner-ip-whitelisting {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .modal-content {
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .modal-header .btn-close {
          padding: 0.5rem;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }
        }
      `}</style>
    </Container>
  );
};

export default ApiPartnerIpWhiteListing;
